module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pullsheet-view"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n      Loading...\n    ")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.tokenCheckResponse) ? _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Set your new password")]), _vm._v(" "), _c('div', {
    staticClass: "password-reset-form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.changePassword($event)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("\n            Email address\n          ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.tokenCheckResponse.email
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("\n            Enter a new password\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "repeatpassword"
    }
  }, [_vm._v("\n            Enter it again\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordrepeat),
      expression: "passwordrepeat"
    }],
    attrs: {
      "type": "password",
      "name": "repeatpassword",
      "placeholder": "Repeat Password"
    },
    domProps: {
      "value": (_vm.passwordrepeat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordrepeat = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('div', {
    staticClass: "formerror"
  }, [_vm._v(_vm._s(_vm.formError))]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit",
      "disabled": _vm.formLoading
    }
  }, [_vm._v("Set new password")])])])]) : _vm._e(), _vm._v(" "), (_vm.complete) ? _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Your password has been reset")]), _vm._v(" "), _c('p', [_vm._v("You can now log in with your new password.")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Password Reset")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45fa32a5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordReset.vue
// module id = 189
// module chunks = 1